import 'react-datepicker/dist/react-datepicker.css'

import { PrimaryRegularButton } from 'components/ReusableComponents/Button/RegularButtons'
import dayjs from 'dayjs'
import { Link } from 'react-router-dom'
import { formatPrice } from 'utils/common'

import DiscountIcon from './Discount'
import styles from './FeaturedRoom.module.scss'
import LastBookingInfoIcon from './LastBookingInfo'
import placeholderImgUrl from './roomPlaceholder.jpg'

const CDN_URLS = {
  prod: 'https://cdn.swaypay.io/'
}

const FeaturedRoom = ({
  rooms,
  previousBooking,
  baseurl = '',
  onSelectRoom,
  env = ''
}) => {
  const colors = {
    primary: '#0770e6'
  }

  const lastBookedRoom = rooms.find(r => r.isLastBooked)
  const cheapestRoom = rooms.find(r => r.isCheapest) || rooms[0]

  function getRoomImage(roomData) {
    let cdnURL = CDN_URLS.prod

    if (env === 'd') {
      cdnURL = CDN_URLS.dev
    }

    if (env === 's') {
      cdnURL = CDN_URLS.sbx
    }

    if (roomData.image) {
      return cdnURL + roomData.image
    } else {
      return placeholderImgUrl
    }
  }

  if (!rooms) {
    return null
  }

  if (lastBookedRoom?.isCheapest) {
    return (
      <>
        <div
          className={styles.singleFeaturedRoomPhoto}
          style={{
            backgroundImage: `url(${getRoomImage(lastBookedRoom)})`
          }}
        ></div>
        <div className={styles.featuredRoom}>
          <div className={styles.featuredRoomInfo}>
            <h1 className={styles.roomName}>{lastBookedRoom.roomName}</h1>
            <p className={styles.roomDesciption}>{lastBookedRoom.description}</p>
            <div className={styles.lastBookingInfo}>
              <LastBookingInfoIcon />
              Guest picked this room at{' '}
              {dayjs(previousBooking?.checkInDate || previousBooking.checkInDate).format(
                'MMM DD, YYYY'
              )}
            </div>
            {lastBookedRoom.cheapestRoomPrice >
              lastBookedRoom.availablePrice.nightlyRateBase && (
              <div className={styles.cheaperThanOTAText}>
                <DiscountIcon />
                {formatPrice(
                  lastBookedRoom.cheapestRoomPrice -
                    lastBookedRoom.availablePrice.nightlyRateBase
                )}{' '}
                cheaper from {lastBookedRoom.cheapestRoomSource}
              </div>
            )}
            {lastBookedRoom.cheapestRoomPrice ===
              lastBookedRoom.availablePrice.nightlyRateBase && (
              <div className={styles.cheaperThanOTAText}>
                <DiscountIcon /> Same price with {lastBookedRoom.cheapestRoomSource}
              </div>
            )}
          </div>
          <div className={styles.featuredBottomBar}>
            <div className={styles.priceHolder}>
              <p className={styles.price} style={{ color: colors.primary }}>
                {formatPrice(lastBookedRoom.availablePrice.nightlyRateBase)}
              </p>
              <p className={styles.priceDescription}>/ night</p>
            </div>
            <Link
              to={`${baseurl}/book/payment`}
              className={styles.bookButton}
              style={{ background: colors.primary }}
              onClick={() => onSelectRoom(lastBookedRoom)}
            >
              Reserve now
            </Link>
          </div>
        </div>
      </>
    )
  } else {
    return (
      <>
        <div className={styles.featuredRoom}>
          <div
            className={styles.featuredRoomPhoto}
            style={{
              backgroundImage: `url(${getRoomImage(cheapestRoom)})`
            }}
          ></div>
          <div className={styles.featuredRoomInfo}>
            <h1 className={styles.roomName}>{cheapestRoom.roomName}</h1>
            <p className={styles.roomDesciption}> {cheapestRoom.description}</p>
            {cheapestRoom.cheapestRoomPrice >
              cheapestRoom.availablePrice.nightlyRateBase && (
              <div className={styles.cheaperThanOTAText}>
                <DiscountIcon />
                {formatPrice(
                  cheapestRoom.cheapestRoomPrice -
                    cheapestRoom.availablePrice.nightlyRateBase
                )}{' '}
                cheaper from {cheapestRoom.cheapestRoomSource}
              </div>
            )}
            {cheapestRoom.cheapestRoomPrice ===
              cheapestRoom.availablePrice.nightlyRateBase && (
              <div className={styles.cheaperThanOTAText}>
                <DiscountIcon /> Same price with {cheapestRoom.cheapestRoomSource}
              </div>
            )}
          </div>
          <div className={styles.featuredBottomBar}>
            <div className={styles.priceHolder}>
              <p className={styles.price} style={{ color: colors.primary }}>
                {formatPrice(cheapestRoom.availablePrice.nightlyRateBase)}
              </p>
              <p className={styles.priceDescription}>/ night</p>
            </div>
            <PrimaryRegularButton
              className={styles.bookButton}
              onClick={() => onSelectRoom(cheapestRoom)}
            >
              Copy link
            </PrimaryRegularButton>
          </div>
        </div>
        {lastBookedRoom && (
          <div className={styles.featuredRoom}>
            <div
              className={styles.featuredRoomPhoto}
              style={{
                backgroundImage: `url(${getRoomImage(lastBookedRoom)})`
              }}
            ></div>
            <div className={styles.featuredRoomInfo}>
              <h1 className={styles.roomName}>{lastBookedRoom.roomName}</h1>
              <p className={styles.roomDesciption}>{lastBookedRoom.description}</p>
              <div className={styles.lastBookingInfo}>
                <LastBookingInfoIcon />
                Guest picked this room at{' '}
                {dayjs(previousBooking.checkInDate).format('MMM DD, YYYY')}
              </div>
            </div>
            <div className={styles.featuredBottomBar}>
              <div className={styles.priceHolder}>
                <p className={styles.price} style={{ color: colors.primary }}>
                  {formatPrice(lastBookedRoom.availablePrice.nightlyRateBase)}
                </p>
                <p className={styles.priceDescription}>/ night</p>
              </div>
              <PrimaryRegularButton
                className={styles.bookButton}
                onClick={() => onSelectRoom(lastBookedRoom)}
              >
                Copy link
              </PrimaryRegularButton>
            </div>
          </div>
        )}
      </>
    )
  }
}

export default FeaturedRoom
